// components/ValidationRefresher.tsx
import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

export const ValidationRefresher = () => {
  const { validateForm } = useFormikContext();
  const { i18n } = useTranslation();

  useEffect(() => {
    validateForm(); // ✅ Revalidate form on language change
  }, [i18n.language]);

  return null;
};
